import { pageHead } from "@/lib/routeHead";
import { createFileRoute } from "@tanstack/react-router";
import ClientDeliverableDetailPage from "@/pages/client/ClientDeliverableDetailPage";

export const Route = createFileRoute("/client/contracts/$contractId/deliverables/$deliverableId")({
  head: () => pageHead("Client · Contracts · Deliverables", "AKIVA client · contracts · deliverables portal.", "/client/contracts/$contractId/deliverables/$deliverableId", true),
  component: ClientDeliverableDetailPage,
});
